module.exports = __webpack_public_path__ + "static/beneficio-2-271613b9d5855572b871a23e7971bdd4.png";